import styled from "styled-components";

const Input = styled.input`
  font-size: 1rem;
  font-weight: 400;
  color: #484848;

  height: 2.63rem;
  width: 100%;
  margin: 0;
  padding: 0;

  outline: none;
  text-indent: ${props => (props.leftIcon ? "1.9375rem" : "0.5rem")};

  border-width: 0.0625rem;
  border-style: solid;
  border-color: ${props => (props.error ? "#f15252" : "#dfdfdf")};
  border-radius: 3px;

  background-color: #fff;

  background-image: ${props => (props.leftIcon ? `url(${props.leftIcon})` : "")};

  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: 8px center;

  transition: border 0.3s ease-in-out;

  &:focus {
    border-color: #a0a0a0;
  }

  &:disabled {
    border-color: #efefef;
    color: #dfdfdf;
  }

  &:required {
    box-shadow: none;
  }

  &:placeholder {
    opacity: 1;
    font-size: 16px;
    color: #a0a0a0;
    font-weight: 300;
  }
  &::-webkit-input-placeholder {
    /* Chrome */
    opacity: 1;
    font-size: 16px;
    color: #a0a0a0;
    font-weight: 300;
    transition: opacity 0.3s ease-in-out;
  }
  &:focus::-webkit-input-placeholder {
    opacity: 0.5;
  }
  &:-ms-input-placeholder {
    /* IE 10+ */
    opacity: 1;
    font-size: 16px;
    color: #a0a0a0;
    font-weight: 300;
    transition: opacity 0.3s ease-in-out;
  }
  &:focus:-ms-input-placeholder {
    opacity: 0.5;
  }
  &::-moz-placeholder {
    /* Firefox 19+ */
    opacity: 1;
    font-size: 16px;
    color: #a0a0a0;
    font-weight: 300;
    transition: opacity 0.3s ease-in-out;
  }
  &:focus::-moz-placeholder {
    opacity: 0.5;
  }
  &:-moz-placeholder {
    /* Firefox 4 - 18 */
    opacity: 1;
    font-size: 16px;
    color: #a0a0a0;
    font-weight: 300;
    transition: opacity 0.3s ease-in-out;
  }
  &:focus:-moz-placeholder {
    opacity: 0.5;
  }
  &:disabled::-webkit-input-placeholder {
    color: #dfdfdf;
  }
  &:disabled:-ms-input-placeholder {
    color: #dfdfdf;
  }
  &:disabled::-moz-placeholder {
    color: #dfdfdf;
  }
  &:disabled:-moz-placeholder {
    color: #dfdfdf;
  }

  &:disabled:placeholder {
    color: #dfdfdf;
  }
`;

export default Input;
